/**
 * Facebook dynamic ads helper
 * https://developers.facebook.com/docs/facebook-pixel/implementation/dynamic-ads
 * this is used in action.js
 */
export const FBTrack = (...args: any) => {
  // LEGACY: moved in GTM
  // if (typeof window.fbq === 'undefined') {
  //   return;
  // }
  //
  // window.fbq(...args);
  //
  // if (process.env.NODE_ENV !== 'production') {
  //   console.log('FBQ:', args);
  // }
};

export const FBQEventId = () => window.__fbdata?.eventID;
export const FBQEventIdObject = () => {
  const eventId = FBQEventId();
  if (!eventId) {
    return {};
  }

  return {
    eventID: FBQEventId,
  };
};
/**
 * Add to cart event
 */
export const FBQAddToCart = data => {
  FBTrack('track', 'AddToCart', data, FBQEventIdObject());
};

/**
 * View content event
 */
export const FBQViewContent = data => {
  FBTrack('track', 'ViewContent', data, FBQEventIdObject());
};

/**
 *
 */
export const FBQPurchase = () => {
  console.warn('not Implement Purchase');
};

export const FBQPageView = () => {
  FBTrack('track', 'PageView', {}, FBQEventIdObject());
};
